define('user/select-org.controller',['angular'], function (angular) {
    'use strict';
    var SelectOrgCtrl = function ($scope, $location, $routeParams, $filter, $localStorage, $mdToast, $document,
                                 userService, dataEntryService, $window, $mdDialog, $sce, helper, user, $rootScope) {
        $scope.user = user;
        $scope.orgSelected = function(){
            for(var i = 0; i < $scope.user.organizations.length; i++){
                if($scope.user.organizations[i].id === Number($scope.selectedOrgId)){
                    $scope.selectedOrgName = $scope.user.organizations[i].name;
                }
            }
        };
        $scope.selectOrg = function(){
            $localStorage.pref_org_id = Number($scope.selectedOrgId);
            $rootScope.$emit('rootScope:updateBadges', {});
            $rootScope.$emit('rootScope:changeOrg');
            $mdDialog.hide(true);
        };

    };
    SelectOrgCtrl.$inject = ['$scope', '$location', '$routeParams', '$filter', '$localStorage', '$mdToast', '$document', 'userService', 'dataEntryService', '$window', '$mdDialog', '$sce', 'helper', 'user', '$rootScope'];
    return SelectOrgCtrl;
});

